import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

function NoMatch() {
  const { t } = useTranslation()

  return (
    <div>
      <div className="text-3xl text-gray-800 mb-4">{t('error.page-not-found')}</div>
      <p>
        <Link to="/" className="text-blue-700">{t('common.go-to-home-page')}</Link>
      </p>
    </div>
  )
}

export default NoMatch
